var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-edit"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    clipPath: "url(#clip-edit)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33287",
    "data-name": "Group 33287",
    transform: "translate(7909.854 -15587.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33288",
    "data-name": "Group 33288",
    transform: "translate(-9603.162 15229.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40460",
    "data-name": "Path 40460",
    d: "M182.481,74.5a.4.4,0,0,0-.108.2l-.557,2.786a.394.394,0,0,0,.387.471.375.375,0,0,0,.077-.008l2.785-.557a.392.392,0,0,0,.2-.108l6.234-6.234-2.785-2.785Zm0,0",
    transform: "translate(1512.902 293.463)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40461",
    "data-name": "Path 40461",
    d: "M395.321,1.077a1.971,1.971,0,0,0-2.785,0l-1.09,1.09,2.785,2.785,1.09-1.091a1.97,1.97,0,0,0,0-2.785Zm0,0",
    transform: "translate(1311.008 358.721)",
    fill: "#434343"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit-pen.e0269d416abcb376266c1c47b5f80511.svg";
export { ForwardRef as ReactComponent };